import { matchPath } from "react-router-dom";

/**
 * Every page App.tsx serves WITHOUT a session: the "Public routes" block that
 * sits ahead of the protected `/:clubid/*` catch-all. A family, a prospect or
 * the kiosk reaches these with no sign-in (the kiosk and the emailed-link
 * pages carry their own token).
 *
 * Kept in step with App.tsx by publicRoutes.parity.test.ts, which reads the
 * block and fails if a route is added there and not here, or the reverse.
 *
 * Sentry CLUB-CENTRAL-TENANT-5G (2026-10): a hand-picked list of five pages
 * missed /:clubid/register, where most of the "Session rejected" reports came
 * from. A family with a lapsed old session who opened Register was sent to
 * "your session expired" instead of the sign-up form.
 */
export const PUBLIC_ROUTE_PATHS: readonly string[] = [
  "/:clubid/login",
  "/:clubid/accept-invite/:token",
  "/:clubid/kiosk",
  "/:clubid/register",
  "/:clubid/trial",
  "/:clubid/feedback/:token",
  "/:clubid/sign-waiver",
  "/:clubid/profile/support-pin/reset",
  "/:clubid/events/:eventId/volunteer-cancel",
  "/:clubid/d/:token",
  "/:clubid/forgot-password",
  "/:clubid/reset-password",
  "/:clubid/magic-login",
  "/:clubid/athlete/login",
  "/:clubid/athlete/progress",
  "/:clubid/members-summary",
  "/:clubid/programs",
  "/:clubid/find",
  "/:clubid/about",
  "/:clubid/contact",
  "/:clubid/faq",
  "/:clubid/privacy",
  "/:clubid/privacy-policy",
  "/:clubid/terms",
  "/:clubid/terms-of-service",
  "/:clubid/cookie-policy",
  "/:clubid/eula",
  "/:clubid/support",
  "/:clubid/accessibility-policy",
  "/:clubid/events",
  "/:clubid/events/:eventId",
  "/:clubid/camps",
  "/:clubid/camps/:campId",
  "/:clubid/clinics",
  "/:clubid/clinics/:clinicId",
  "/:clubid/book",
  "/:clubid/posts",
  "/:clubid/posts/:slug",
  "/:clubid/m/:slug",
  "/:clubid/shared/:token",
  "/:clubid/embed/register",
  "/:clubid/embed/camps",
  "/:clubid/embed/camps/:campId",
  "/:clubid/embed/clinics",
  "/:clubid/embed/clinics/:clinicId",
  "/:clubid/embed/events",
  "/:clubid/embed/events/:eventId",
  "/:clubid/embed/contact",
  "/",
  "/sms-opt-in",
  "/privacy",
  "/privacy-policy",
  "/terms",
  "/terms-of-service",
];

/** True when `pathname` is one of the pages above (matched the way the router matches). */
export function isPublicPathname(pathname: string): boolean {
  return PUBLIC_ROUTE_PATHS.some((path) => matchPath({ path, end: true }, pathname) !== null);
}
